import * as React from "react";
import { OTPInput, OTPInputContext } from "input-otp";

const InputOTP = React.forwardRef(
   ({ className, containerClassName, ...props }, ref) => {
      return (
         <OTPInput
            ref={ref}
            containerClassName={`flex items-center gap-2 has-[:disabled]:opacity-50 ${containerClassName}`}
            className={`disabled:cursor-not-allowed ${className}`}
            {...props}
         />
      )
   }
);
InputOTP.displayName = "InputOTP";

const InputOTPGroup = React.forwardRef(({ className, ...props }, ref) => (
   <div ref={ref} className={`flex items-center ${className}`} {...props} />
));
InputOTPGroup.displayName = "InputOTPGroup";

const InputOTPSlot = React.forwardRef(({ index, className, message, ...props }, ref) => {
   const inputOTPContext = React.useContext(OTPInputContext);
   const { char, hasFakeCaret, isActive } = inputOTPContext.slots[index];

   return (

      <div
         ref={ref}
         isFocused={true}
         className={` relative flex  items-center justify-center border border-primary border-input text-base transition-all rounded-md last:rounded-r-md ${isActive
            ? " ring-1 ring-primary ring-ring ring-offset-background caret-black"
            : "bg-white "
            } ${message && 'ring-1 ring-red-500'} ${className}`}
         {...props}
      >

         {char}
         {hasFakeCaret && (
            <div className='pointer-events-none absolute inset-0 flex items-center justify-center'>
               <div className='h-4 w-px animate-caret-blink bg-primary duration-1000' />
            </div>
         )}
      </div>
   );
});
InputOTPSlot.displayName = "InputOTPSlot";

const InputOTPSeparator = React.forwardRef(({ ...props }, ref) => (
   <div ref={ref} role='separator' {...props}>
      <span>•</span>
   </div>
));
InputOTPSeparator.displayName = "InputOTPSeparator";

export { InputOTP, InputOTPGroup, InputOTPSlot, InputOTPSeparator };